import { faMobile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { AvailableDeviceType } from '../../misc/api/apiTypes';
import LoadingWithMessage from '../../misc/components/LoadingWithMessage';

export interface DeviceListProps {
    isFetching: boolean;
    selectedOption: string;
    handleChange: (changeEvent) => void;
    devices: Array<AvailableDeviceType>;
}

export const DeviceList = (props: DeviceListProps) => {
    if (props.isFetching) {
        return (<LoadingWithMessage message="Loading Devices..." />);
    } else if (props.devices !== undefined) {
        const listItems = props.devices.map((device) =>
            <li key={device.Key}>
                <input id={device.Key} type="radio" value={device.Key} checked={props.selectedOption === device.Key} onChange={props.handleChange} />
                <label htmlFor={device.Key}>
                    <span className="posh-select-icon"><FontAwesomeIcon icon={faMobile} aria-hidden="true" /></span>
                    <span className="posh-select-body">
                        <span className="posh-select-title">{device.Name}</span>
                        <span className="posh-select-description text-muted">{device.Description}</span>
                    </span>
                </label>
            </li>
        );

        return (
            <div>
                <p className="text-muted">Select the device you are trying to connect:</p>
                <ul className="posh-select">{listItems}</ul>
            </div>
        );
    } else {
        return null;
    }
}
